import { NULL } from "constants/primitives";
import dispatchJSEvent from "./dispatchJSEvent";


// That's event that any of the static values has been changed, so the scripts handling public api, like react package can listen to and update context.
// It's always in whitelabel mode, to not interfer with package, that will not know if that is whitelabel or not.
export const EVENT_NAME = `banner_cookie_api_sync`;

const dispatchApiSyncEvent = (
) => {
  const jsEventData = NULL
  dispatchJSEvent(EVENT_NAME, jsEventData);
};

export default dispatchApiSyncEvent;
